const browserEnv = (window as any).__env || {};

export const environment = {
  production: true,
  secretKeyHMAC: browserEnv.secretKeyHMAC,
  base: browserEnv.base || '',
  backendHost: browserEnv.backendHost,
  backendPort: browserEnv.backendPort,
  push: {
    vapidPublicKey: browserEnv.vapidPublicKey || '',
  },
};

// env